@if (src().startsWith("/icons/")) {
  <img [ngSrc]="src()" [height]="height()" [width]="width()" [alt]="alt"/>
} @else {
  <span [style.font-size]="width() + 'px'">{{ src() }}</span>
}

